module.exports = __webpack_public_path__ + "img/0d00840.jpg";